import projects1 from "../../assets/images/project1.png";
import projects2 from "../../assets/images/project2.png";
import projects4 from "../../assets/images/project4.png";
import projects5 from "../../assets/images/crypto.png";
import projects6 from "../../assets/images/products-redux.png";

export const projects = [
  {
    name: "WAED ACADEMIO",
    img: projects1,
    technologies: ["React.js", "Tailwindcss"],
    description:
      "The Waed website represents a React.js front-end project that showcases the dedication to providing high-quality language education in German, English, and French. This interactive platform allows students to explore our diverse course offerings, access valuable resources, and learn about our exam preparation services, including TOEFL, IELTS, TCF, and more.",
    live: "https://waed-academio.vercel.app/",
    github: "https://github.com/wolfcodie/waed-academio-MERN",
  },
  {
    name: "CASAPAPEL",
    img: projects2,
    technologies: ["React.js", "Tailwindcss"],
    description:
      "The Casapapel Maroc website is more than just a virtual gateway; it's an embodiment of simplicity and elegance. Powered by React.js and meticulously crafted in Figma, their user-friendly interface is designed to make the online experience seamless.",
    live: "https://casapapelmaroc.vercel.app/",
    github: "https://github.com/wolfcodie/casapapel",
  },
  {
    name: "SideShift",
    img: projects5,
    technologies: ["React.js"],
    description:
      "Experience Effortless Crypto Conversions with React.js and API Integration. Their responsive website, powered by React.js and React Router, empowers you to seamlessly shift between BTC, ETH, BCH, XMR, XAI, and over 100 other cryptocurrencies—all without the need for an account. Explore a user-friendly platform that harnesses the potential of cutting-edge technologies.",
    live: "https://crypto-swap-alpha.vercel.app",
    github: "https://github.com/wolfcodie/cryptoSwap",
  },
  {
    name: "Products Cart Redux Toolkit",
    img: projects6,
    technologies: ["React.js", "Redux", "Toolkit ", "API"],
    description: "",
    live: "https://products-redux-nu.vercel.app/",
    github: "https://github.com/wolfcodie/productsRedux",
  },
];
